module.exports = __webpack_public_path__ + "img/bg.3c3edc7d.jpg";